import React, { useEffect, useState } from "react";
import { Loader2, Plus, Trash2, Star } from "lucide-react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

const ReviewsAdmin = () => {
  const [reviews, setReviews] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ author: "", city: "", rating: 5, lang: "fr", comment: "" });
  const load = () => api.get("/admin/reviews").then((r) => { setReviews(r.data); setLoading(false); });
  useEffect(() => { load(); api.get("/cities").then((r) => { setCities(r.data); setF((p) => ({ ...p, city: r.data[0]?.name || "" })); }); }, []);
  const create = async () => { if (!f.author || !f.comment) return; await api.post("/admin/reviews", { ...f, rating: Number(f.rating) }); toast.success("Avis ajouté"); setF({ ...f, author: "", comment: "" }); load(); };
  const del = async (id) => { await api.delete(`/admin/reviews/${id}`); load(); };
  if (loading) return <div className="grid place-items-center h-64"><Loader2 className="w-10 h-10 animate-spin text-brand" /></div>;

  return (
    <div>
      <h1 className="font-heading font-extrabold text-3xl text-ink mb-8">Avis clients</h1>
      <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm mb-6 grid gap-3 sm:grid-cols-2">
        <input data-testid="review-author" placeholder="Auteur" value={f.author} onChange={(e) => setF({ ...f, author: e.target.value })} className="h-12 rounded-xl border-2 border-slate-200 px-3" />
        <select value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className="h-12 rounded-xl border-2 border-slate-200 px-3">{cities.map((c) => <option key={c.id}>{c.name}</option>)}</select>
        <select value={f.rating} onChange={(e) => setF({ ...f, rating: e.target.value })} className="h-12 rounded-xl border-2 border-slate-200 px-3">{[5, 4, 3, 2, 1].map((n) => <option key={n} value={n}>{n} étoiles</option>)}</select>
        <select value={f.lang} onChange={(e) => setF({ ...f, lang: e.target.value })} className="h-12 rounded-xl border-2 border-slate-200 px-3">{["fr", "en", "es", "it"].map((l) => <option key={l}>{l}</option>)}</select>
        <textarea data-testid="review-comment" placeholder="Commentaire" value={f.comment} onChange={(e) => setF({ ...f, comment: e.target.value })} className="sm:col-span-2 rounded-xl border-2 border-slate-200 px-3 py-2" rows={2} />
        <Button onClick={create} data-testid="save-review-btn" className="h-12 rounded-full bg-brand text-white font-bold sm:col-span-2"><Plus className="w-5 h-5 mr-1" /> Ajouter l'avis</Button>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {reviews.map((r) => (
          <div key={r.id} className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm">
            <div className="flex justify-between items-start">
              <div className="flex gap-0.5">{[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`w-4 h-4 ${i <= r.rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />)}</div>
              <button onClick={() => del(r.id)} className="text-red-500 hover:text-red-700"><Trash2 className="w-5 h-5" /></button>
            </div>
            <p className="text-base text-ink my-2">“{r.comment}”</p>
            <span className="text-sm font-semibold text-ink-muted">{r.author} · {r.city}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewsAdmin;
